import { render, staticRenderFns } from "./EndingLettersExpanded.vue?vue&type=template&id=f9e051ae"
import script from "./EndingLettersExpanded.vue?vue&type=script&lang=js"
export * from "./EndingLettersExpanded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports